import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabGroup } from '@angular/material/tabs';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModel } from 'src/app/models/paginationModel';

@Component({
    selector: 'app-notification-approvers',
    templateUrl: './notification-approvers.component.html',
    styleUrls: ['./notification-approvers.component.css'],
    providers: [NgxSpinnerService]
})

export class NotificationApproversComponent implements OnInit {
    @ViewChild('tabs') tabGroup: MatTabGroup;
    groupId: any;
    groupName: any;
    rolesApprovers = ["Admin","Supervisor"];
    rolesUsers = ["Admin","Supervisor"];
    rFilterUser = "select";
    rFilterApprovers = "select";
    userStatus = 2;
    checkedApprovers = [];
    checkedUsers = [];
    modalOptions: NgbModalOptions = {};
    scrHeight:any;
    scrWidth:any;
    appNotis = { option: "" };
    currentUserId:any;
    expired:any;

    //Approvers users table
    displayedColumnsApprovers: string[] = ['check', 'profileFirstName', 'userEmail', 'userRole', 'userActive'];
    dataSourceApprovers:any = new MatTableDataSource<any>();
    totalLengthApprovers = 0;
    activeApprovers = "ProfileFirstName";
    directionApprovers = "ASC";
    pageIndexApprovers = 0; 
    pageSizeApprovers = 5;
    filterApprovers = "";
    filterApproversApplied = false;
    @ViewChild('SortApprovers', {static: true}) sortApprovers: MatSort;
    @ViewChild('PaginatorApprovers', {static: true}) paginatorApprovers: MatPaginator;
    
    //Users table
    displayedColumnsUsers: string[] = ['check', 'profileFirstName', 'email', 'role'];
    dataSourceUsers:any = new MatTableDataSource<any>();
    totalLengthUsers = 0;
    activeUsers = "ProfileFirstName";
    directionUsers = "ASC";
    pageIndexUsers = 0;
    pageSizeUsers = 5;
    filterUsers = "";
    filterUsersApplied = false;
    @ViewChild('SortUsers', {static: true}) sortUsers: MatSort;
    @ViewChild('PaginatorUsers', {static: true}) paginatorUsers: MatPaginator;

    constructor(
        public functionsService: FunctionsService,
        private apiService: ApiService,
        private modalService: NgbModal,
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private route: ActivatedRoute,
        private pagination: PaginationModel) { 
            this.functionsService.setTitle('breadcrumb.notification-approvers');
            this.route.params.subscribe(params => {
                this.groupId = params['groupId'];
                this.groupName = params['groupName'];
            });
        }

     async ngOnInit(){
        this.currentUserId = await this.functionsService.getUserId();
        this.expired = await this.functionsService.isExpired();
        this.getScreenSize();
        this.dataSourceApprovers.sort = this.sortApprovers;
        this.dataSourceUsers.sort = this.sortUsers;
        this.modalOptions.backdrop = 'static';
        this.modalOptions.keyboard = false;
        this.modalOptions.size = 'lg';
        this.translate.onLangChange.subscribe(() => {
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
        });
        this.getApprovalStatus();
        this.fetchNotificationApprovers();
        this.fetchPotentialApprovers();
    }

    async getApprovalStatus(){
        (await this.apiService.approveNotificationsStatus()).subscribe(
            data => {
                this.appNotis = { option: data["approve"]?"1":"0" };
                if(data["approve"]){
                    document.getElementById("enable_approval").hidden = false;
                    this.fetchNotificationApprovers();
                    this.fetchPotentialApprovers();
                }else{
                    document.getElementById("enable_approval").hidden = true;
                }
            },
            error => {
                this.appNotis = { option: "0" }
            }
        );
    }

    approveNotis(value){
        this.spinner.show();
        this.apiService.updateApproveNotiStatus(value).subscribe(
            data => {
                if(value){
                    this.fetchPotentialApprovers();
                    this.fetchNotificationApprovers();
                    document.getElementById("enable_approval").hidden = false;
                }else{
                    if(data!="")
                    {
                        this.appNotis = { option: "1" }
                        var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
                        modalRef.componentInstance.title = this.translate.instant('Error');
                        modalRef.componentInstance.message = this.translate.instant(data.toString());
                    }
                    else{
                        document.getElementById("enable_approval").hidden = true;
                    }
                }
                this.spinner.hide();
            },
            error => {
                this.getApprovalStatus();
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    roleFilterUser: string = "_role";
    changeRoleUserLabel(role: string) {
        this.rFilterUser = role;
        this.roleFilterUser = role;
    }

    roleFilterApprovers: string = "select_role";
    changeRoleApproversLabel(role: string) {
        this.rFilterApprovers = role;
        this.roleFilterApprovers = role;
    }

    statusObject = {"active":1, "inactive":0};
    statusFilter: string = "select_status";
    statuses: string[] = Object.keys(this.statusObject);
    changeStatusFilterLabel(status) {
        this.statusFilter = status;
        this.userStatus = this.statusObject[status];
    }

    fetchNotificationApprovers(){
        if(!this.filterApproversApplied){
            this.clearFilterApprovers();
        }
        this.pagination.GroupId = this.groupId;
        this.pagination.Page = this.pageIndexApprovers;
        this.pagination.PageSize = this.pageSizeApprovers;
        this.pagination.OrderBy =this.activeApprovers;
        this.pagination.Order =this.directionApprovers;
        this.pagination.Role = this.rFilterApprovers;
        this.pagination.Status = this.userStatus;
        this.pagination.Filter = this.filterApprovers;
        this.spinner.show();
        this.apiService.getNotificationApprovers(this.pagination).subscribe(
            data => {
                var checkbox = <HTMLInputElement>document.getElementById('checkAllApprovers');
                if(checkbox&&checkbox.checked){
                    checkbox.checked = false;
                }
                this.dataSourceApprovers.data = Object.values(data)[0];
                this.totalLengthApprovers = parseInt(Object.keys(data)[0]);
                if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
                }
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
            }
        );
    }

    fetchPotentialApprovers(){
        if(!this.filterUsersApplied){
            this.clearFilterUsers();
        }
        this.pagination.GroupId = this.groupId;
        this.pagination.Page = this.pageIndexUsers;
        this.pagination.PageSize = this.pageSizeUsers;
        this.pagination.OrderBy =this.activeUsers;
        this.pagination.Order =this.directionUsers;
        this.pagination.Role = this.rFilterUser;
        this.pagination.Filter = this.filterUsers;
        this.spinner.show();
        this.apiService.getPotentialApprovers(this.pagination).subscribe(
            data => {
                var checkbox = <HTMLInputElement>document.getElementById('checkAllUsers');
                if(checkbox&&checkbox.checked){
                    checkbox.checked = false;
                }
                this.dataSourceUsers.data = Object.values(data)[0];
                this.totalLengthUsers = parseInt(Object.keys(data)[0]);
                if(document.getElementsByClassName("mat-paginator-page-size-label")[1]){
                    document.getElementsByClassName("mat-paginator-page-size-label")[1].innerHTML = this.translate.instant("paginator.items_per_page");
                }
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
            }
        );
    }

    nextPageApprovers(evt){
        this.pageIndexApprovers = evt.pageIndex;
        this.pageSizeApprovers = evt.pageSize;
        this.fetchNotificationApprovers();
    }

    sortDataApprovers(evt){
        this.activeApprovers = evt.active.replace("user", "");
        this.directionApprovers = evt.direction;
        this.fetchNotificationApprovers();
    }

    applyFilterApprovers() {
        var checkbox = <HTMLInputElement>document.getElementById('checkAllApprovers');
        if(checkbox.checked){ 
            checkbox.checked = false;
        }
        this.checkedApprovers = [];
        this.filterApprovers = (<HTMLInputElement>document.getElementById("filterApprovers")).value;
        this.filterApprovers = this.filterApprovers.trim().toLowerCase();
        this.filterApproversApplied = true;
        this.fetchNotificationApprovers();
    }

    clearFilterApprovers(){
        this.rFilterApprovers = "select";
        this.roleFilterApprovers = "select_role";
        this.filterApprovers = "";
        this.userStatus = 2;
        this.statusFilter = "select_status";
        if((<HTMLInputElement>document.getElementById("filterApprovers"))){
            (<HTMLInputElement>document.getElementById("filterApprovers")).value = "";
        }
        if(this.filterApproversApplied){
            this.filterApproversApplied = false;
            this.fetchNotificationApprovers();
        }
    }

    emptyInputApprovers(){
        if((<HTMLInputElement>document.getElementById("filterApprovers")).value == ""){
            this.filterApprovers = "";
            this.fetchNotificationApprovers();
        }
    }

    nextPageUsers(evt){
        this.pageIndexUsers = evt.pageIndex;
        this.pageSizeUsers = evt.pageSize;
        this.fetchPotentialApprovers();
    }

    sortDataUsers(evt){
        this.activeUsers = evt.active;
        this.directionUsers = evt.direction;
        this.fetchPotentialApprovers();
    }

    applyFilterUsers() {
        var checkbox = <HTMLInputElement>document.getElementById('checkAllUsers');
        if(checkbox.checked){ 
            checkbox.checked = false;
        }
        this.checkedUsers = [];
        this.filterUsers = (<HTMLInputElement>document.getElementById("filterUsers")).value;
        this.filterUsers = this.filterUsers.trim().toLowerCase();
        this.filterUsersApplied = true;
        this.fetchPotentialApprovers();
    }

    clearFilterUsers(){
        this.rFilterUser = "select";
        this.roleFilterUser = "select_role";
        this.filterUsers = "";
        if((<HTMLInputElement>document.getElementById("filterUsers"))){
            (<HTMLInputElement>document.getElementById("filterUsers")).value = "";
        }
        if(this.filterUsersApplied){
            this.filterUsersApplied = false;
            this.fetchPotentialApprovers();
        }
    }

    emptyInputUsers(){
        if((<HTMLInputElement>document.getElementById("filterUsers")).value == ""){
            this.filterUsers = "";
            this.fetchPotentialApprovers();
        }
    }

    checkAllApprovers() {
        var checkbox = <HTMLInputElement>document.getElementById('checkAllApprovers');
        var checkboxes = document.getElementsByName('selectedApprovers');
        var approverDisabled = false;
        for(var i=0, n=checkboxes.length;i<n;i++) {
            approverDisabled = (<HTMLInputElement>document.getElementById(checkboxes[i].id.toString())).disabled;
            if((checkbox.checked)&&(!approverDisabled))
            {
                if(!this.checkedApprovers.includes(checkboxes[i].id.toString())){
                    this.checkedApprovers.push(checkboxes[i].id.toString());
                }
                (<HTMLInputElement>document.getElementById(checkboxes[i].id)).checked = true;
            }
            else{
                (<HTMLInputElement>document.getElementById(checkboxes[i].id)).checked = false;
            }
        }

        if(!checkbox.checked){
            this.checkedApprovers = [];
        }
    }
    checkAllUsers() {
        var checkbox = <HTMLInputElement>document.getElementById('checkAllUsers');
        var checkboxes = document.getElementsByName('selectedUsers');
        var userDisabled = false;
        for(var i=0, n=checkboxes.length;i<n;i++) {
            userDisabled = (<HTMLInputElement>document.getElementById(checkboxes[i].id.toString())).disabled;
            if((checkbox.checked)&&(!userDisabled))
            {
                if(!this.checkedUsers.includes(checkboxes[i].id.toString())){
                    this.checkedUsers.push(checkboxes[i].id.toString());
                }
                (<HTMLInputElement>document.getElementById(checkboxes[i].id)).checked = true;
            }
            else{
                (<HTMLInputElement>document.getElementById(checkboxes[i].id)).checked = false;
            }
        }

        if(!checkbox.checked){
            this.checkedUsers = [];
        }
    }

    selectUser(id){
        var checkbox = <HTMLInputElement>document.getElementById('checkAllUsers');
        if((<HTMLInputElement>document.getElementById(id)).checked){
            if(!this.checkedUsers.includes(id.toString())){
                this.checkedUsers.push(id.toString());
            }
        }
        else 
        {
            const index: number = this.checkedUsers.indexOf(id.toString());
            if (index !== -1) {
                this.checkedUsers.splice(index, 1);
            }  
        }
        checkbox.checked = false;  
    }

    selectApprovers(id){
        var checkbox = <HTMLInputElement>document.getElementById('checkAllApprovers');
        if((<HTMLInputElement>document.getElementById(id)).checked){
            if(!this.checkedApprovers.includes(id.toString())){
                this.checkedApprovers.push(id.toString());
            }
        }
        else 
        {
            const index: number = this.checkedApprovers.indexOf(id.toString());
            if (index !== -1) {
                this.checkedApprovers.splice(index, 1);
            }  
        }
        checkbox.checked = false; 
    }

    removeApprovers(){
        if(this.checkedApprovers.length>0)
        {
            const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
            confirmModalRef.componentInstance.title = this.translate.instant('setting.remove_approvers');
            
            confirmModalRef.componentInstance.message = this.translate.instant('setting.remove_approvers_prompt');
            confirmModalRef.result.then(confirmed => {
                if (confirmed) {
                    this.spinner.show();
                    //Remove all approvers
                    this.apiService.removeNotiApprovers(this.checkedApprovers).subscribe(
                        data => {
                            this.checkedApprovers = [];
                            (<HTMLInputElement>document.getElementById('checkAllApprovers')).checked = false;
                            this.clearFilterApprovers();
                            this.fetchNotificationApprovers();
                            this.fetchPotentialApprovers();
                            this.spinner.hide();
                        },
                        error => {
                            this.functionsService.errorHandler(error["status"]);
                            this.spinner.hide();
                        }
                    );
                }
            });
        }
        else {
            var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
            modalRef.componentInstance.title = this.translate.instant('Error');
            modalRef.componentInstance.message = this.translate.instant('group.no_users');

            modalRef.result.then(() => {
                this.modalService.dismissAll();
            });
        }
    }

    assignUsers(){
        if(this.checkedUsers.length > 0){
            const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
            confirmModalRef.componentInstance.title = this.translate.instant('setting.assign_approvers');
            
            confirmModalRef.componentInstance.message = this.translate.instant('setting.assign_approvers_prompt');
            confirmModalRef.result.then(confirmed => {
                if (confirmed) {
                    this.spinner.show();
                    //Add selected users from group
                    //GroupId, array with user ids
                    this.apiService.addNotiApprovers(this.checkedUsers).subscribe(
                        () => {
                            (<HTMLInputElement>document.getElementById('checkAllUsers')).checked = false;
                            this.checkedUsers = [];
                            this.clearFilterUsers();
                            this.fetchNotificationApprovers();
                            this.fetchPotentialApprovers();
                            this.spinner.hide();
                        },
                        error => {
                            this.functionsService.errorHandler(error["status"]);
                            this.spinner.hide();
                        }
                    );
                }
            });
        }
        else {
            var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
            modalRef.componentInstance.title = this.translate.instant('Error');
            modalRef.componentInstance.message = this.translate.instant('group.no_users');

            modalRef.result.then(() => {
                this.modalService.dismissAll();
            });
        }
    }

    tabChanged(evt){
        this.checkedApprovers = [];
        this.checkedUsers = [];
        
        if(evt==1){
            this.pageSizeUsers = 5;
            this.pageIndexUsers = 0;
            this.clearFilterApprovers();
            this.fetchPotentialApprovers();
        }else{
            this.pageSizeApprovers = 5;
            this.pageIndexApprovers = 0;
            this.clearFilterUsers();
            this.fetchNotificationApprovers();
        }
    }

    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumnsApprovers = ['check', 'profileFirstName', 'userEmail', 'userRole', 'userActive'];
        this.displayedColumnsUsers = ['check', 'profileFirstName', 'email', 'role'];
        if(this.scrWidth <= 375){
            this.displayedColumnsApprovers = ['check', 'userEmail'];
            this.displayedColumnsUsers = ['check', 'email'];
        }
        else if(this.scrWidth <= 440){
            this.displayedColumnsApprovers = ['check', 'userEmail', 'userRole'];
            this.displayedColumnsUsers = ['check', 'email', 'role'];
        }
        else if(this.scrWidth <= 600){
            this.displayedColumnsApprovers = ['check', 'profileFirstName', 'userEmail', 'userRole'];
        }
    }
}
